import { Box } from "@mui/material";

export default function Dashboard() {
  return <Box className="dashboard"></Box>;
}
